const clubs = state => state.clubs;

const clubsLoading = state => state.clubsLoading;

const clubsMeta = state => state.meta;

const club = state => state.club;

const clubLoading = state => state.clubLoading;

const videos = state => state.videos;

const videosLoading = state => state.videosLoading;

const limitedVideos = state => state.limitedVideos;

const clubNameExists = state => state.clubNameExists;

const clubNameLoading = state => state.clubNameLoading;

const createClub = state => state.createClub;

const createClubLoading = state => state.createClubLoading;

const clubImages = state => state.clubImages;

const clubImagesLoading = state => state.clubImagesLoading;

const deleteImages = state => state.clubImages;

const deleteImagesLoading = state => state.clubImagesLoading;

const allClubs = state => state.allClubs;

const allClubsLoading = state => state.allClubsLoading;

export default {
  clubs,
  clubsLoading,
  clubsMeta,
  club,
  clubLoading,
  videos,
  videosLoading,
  limitedVideos,
  clubNameExists,
  clubNameLoading,
  createClub,
  createClubLoading,
  clubImages,
  clubImagesLoading,
  deleteImages,
  deleteImagesLoading,
  allClubs,
  allClubsLoading
};
